import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { PromotionInput } from "@core/types";
import * as api from "./api";
import type { PromotionMoveDirection } from "./api";

const key = ["portal", "promotions"] as const;

// SPEC-206 no pagina: el portal trae el catálogo completo en el orden
// manual, mismo criterio que `useOffers`/`useWelcome`.
export const usePromotions = () =>
  useQuery({ queryKey: key, queryFn: api.listPromotions });

export function usePromotionMutations() {
  const client = useQueryClient();
  const invalidate = () => client.invalidateQueries({ queryKey: key });
  return {
    create: useMutation({
      mutationFn: (input: PromotionInput) => api.createPromotion(input),
      onSuccess: invalidate,
    }),
    edit: useMutation({
      mutationFn: ({ id, input }: { id: string; input: PromotionInput }) =>
        api.editPromotion(id, input),
      onSuccess: invalidate,
    }),
    inactivate: useMutation({
      mutationFn: (id: string) => api.inactivatePromotion(id),
      onSuccess: invalidate,
    }),
    move: useMutation({
      mutationFn: ({
        id,
        direction,
      }: {
        id: string;
        direction: PromotionMoveDirection;
      }) => api.movePromotion(id, direction),
      onSuccess: invalidate,
    }),
  };
}
